module.exports = __webpack_public_path__ + "static/velkomin-a-Fjarhátíð-Marel-9e61ea353f31fddd1db17052dac1e5c6.png";